import React, { useState, useEffect, useRef } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import "./classes/SalesByDisplay.css";
import "./classes/Main.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faShoppingBasket, faPrint } from "@fortawesome/free-solid-svg-icons";
import { Helmet } from "react-helmet";
import { useReactToPrint } from "react-to-print";
import { configData } from "../config";
import { toWords } from 'number-to-words';
import Pagination from "./Pagination";

const SalesByDisplay = () => {
  // const products = [
  //   { id: 1, name: "turmeric powder", price: 5, barcode: "10001", stock: 150 },
  //   { id: 2, name: "amla juice", price: 6, barcode: "10002", stock: 84 },
  //   { id: 3, name: "mixed fruits", price: 7, barcode: "10003", stock: 100 },
  //   { id: 4, name: "bath soap", price: 8, barcode: "10004", stock: 120 },
  //   { id: 5, name: "toothpaste", price: 4, barcode: "10005", stock: 180 }
  // ];
//   const mockImages = [
//     '/images/sweet2.png',
//     '/images/sweet1.png',
//     '/images/sweet3.png',
//     '/images/sweet4.png',
//     '/images/sweet5.png',
//     '/images/sweet4.png',
// ];

  /* ---------------- STATE ---------------- */
  const API_BASE = configData.APP_URL;
  const [searchValue, setSearchValue] = useState("");
  const [barcodeValue, setBarcodeValue] = useState("");
  const [customerSearch, setCustomerSearch] = useState("");
  const [customerOptions, setCustomerOptions] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [cart, setCart] = useState([]);
  const [cashPaid, setCashPaid] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [items, setItems] = useState([]);
  const [customerType, setCustomerType] = useState("retail"); 
  const [paymentType, setPaymentType] = useState("cash"); // could be "cash" or "card"
  const [taxType, setTaxType] = useState("intra");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [invoiceNumber, setInvoiceNumber] = useState(null);
  const [companyDetail, setCompanyDetail] = useState(null);
  const inputSearchRef = useRef(null);
  const [printType, setPrintType] = useState("receipt-58mm");
  const [showPrintPopup, setShowPrintPopup] = useState(false);
  const [invoiceNumberForPrint, setInvoiceNumberForPrint] = useState(null);


  /* ---------------- PRODUCT FILTER (NAME ONLY) ---------------- */
  const filteredItems = items.filter(item =>
    item.name?.toLowerCase().includes(searchValue.toLowerCase())
  );

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 15;

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo(0,0);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchValue]);

  useEffect(() => {
    const inputs = document.querySelectorAll(".no-scroll");

    const ignoreScroll = (e) => e.preventDefault();

    inputs.forEach((el) => {
      el.addEventListener("wheel", ignoreScroll, { passive: false });
    });

    return () => {
      inputs.forEach((el) => {
        el.removeEventListener("wheel", ignoreScroll);
      });
    };
  }, []);

  useEffect(() => {
    if (companyDetail && inputSearchRef.current) {
      setTimeout(() => {
        inputSearchRef.current.focus();
      }, 150);
    }
  }, [companyDetail]);

   const handleKeyDown = (e) => {
  if (e.key === "Enter") {
    e.preventDefault();

    const code = barcodeValue.trim();
    if (!code) return;

    //  Find product manually
    const item = items.find(i => i.barcode === code);

    if (item) {
      addToCart(item);
    } else {
      alert("Product not found for barcode: " + code);
    }

    //  Clear + refocus
    setBarcodeValue("");
    setTimeout(() => inputSearchRef.current?.focus(), 0);
  }
};
  const fetchInvoiceNumber = async () => {
    try {
      const res = await fetch(API_BASE + "salesapi/get-invoice-number");
      const data = await res.json();
  
      if (data.success) {
        setInvoiceNumber(data.invoice_number);
        return data.invoice_number;
      }
    } catch (error) {
      console.error("Error fetching invoice number:", error);
    }
  };

  useEffect(() => {
    fetchInvoiceNumber();
  }, []);

   useEffect(() => {
    if (!customerSearch.trim()) {
      setCustomerOptions([]);
      return;
    }
  
    const timer = setTimeout(async () => {
      try {
        const res = await fetch(
          API_BASE + "salesapi/getcustomerlist?query=" + customerSearch
        );
        const data = await res.json();
        setCustomerOptions(data || []);
      } catch (err) {
        console.error("Customer fetch error", err);
      }
    }, 400);
  
    return () => clearTimeout(timer);
  }, [customerSearch]);
const fetchItems = async () => {
  try {
    setLoading(true);
    const res = await fetch(`${API_BASE}items/lists`);
    const data = await res.json();

    let list = [];
    if (Array.isArray(data)) {
      list = data;
    } else if (data?.data && Array.isArray(data.data)) {
      list = data.data;
    } else if (data?.items && Array.isArray(data.items)) {
      list = data.items;
    }

    //  NORMALIZE BACKEND FIELDS
    const normalized = list.map(item => ({
      id: item.id,
      name: item.item_name,
      barcode: item.barcode,
      retail: item.retail_price ?? item.retail ?? 0,
      wholesale: item.wholesale_price ?? item.wholesale ?? 0,
      stock: item.stock ?? item.quantity_stock ?? 0,
      tax_one: Number(item.tax_one || 0),
      tax_two: Number(item.tax_two || 0),
      unit: item.unit,
      image: item.product_image
          ? `${API_BASE}${item.product_image}`   // if relative path
          : "/images/img_unavailable.png"
    }));
//  const itemsWithImages = normalized.map((item, index) => ({
//   ...item,
//   image: mockImages[index % mockImages.length], // cycle through mock images
// }));

    setItems(normalized);
  } catch (error) {
    console.error("Error fetching items:", error);
    setItems([]);
  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
    fetchItems();
  }, []);

//   const componentRef = useRef(null);
//   const handlePrint = useReactToPrint({
//     content: () => componentRef.current,
//     documentTitle: "Receipt"
//   });
  const contentRef = useRef(null);

  const focusBarcode = () => {
    setTimeout(() => {
      inputSearchRef.current?.focus();
    }, 100);
  };

const handleAfterPrint = () => {
  resetSale();
  focusBarcode();
};

  const handlePrint = useReactToPrint({
    contentRef: contentRef,
    documentTitle: "Receipt",
    onAfterPrint: handleAfterPrint,
  });
    const getRowConfig = (type) => {
        switch (type) {
            case "invoice-a4":
            return { FIRST: 30, LAST: 15 };
            case "receipt-152mm":
            return { FIRST: 12, LAST: 5 };
            default:
            return { FIRST: 30, LAST: 15 };
        }
    };

    const onPrintClick = (size) => {
    if (cart.length === 0) return;
    // if (paymentType === "cash") {
      const cash = parseFloat(cashPaid) || 0;
      if (cash < roundedTotal) {
        // alert(`Cash received (₹${cash.toFixed(2)}) is less than total (₹${grandTotal.toFixed(2)}). Please enter the correct amount.`);
        return;
      }
    // }
    setPrintType(size);
    setShowPrintPopup(false);
    setTimeout(() => {
      handlePrint();
      // setTimeout(() => {
      //   resetSale();
      // }, 500);
    }, 100);
  };

  const canSaveOrPrint = () => {
    if (cart.length === 0) return false;
    // if (paymentType === "cash") {
    //   const cash = parseFloat(cashReceived) || 0;
    //   return cash >= grandTotal;
    // }
    return true;
  };


  /* ---------------- BARCODE SCAN (ONLY ADD TO CART) ---------------- */
// useEffect(() => {
//   if (!barcodeValue) return;

//   if (/^\d+$/.test(barcodeValue)) {
//     const item = items.find(i => i.barcode === barcodeValue);
//     if (item) {
//       addToCart(item);
//       setBarcodeValue("");
//     }
//   }
// }, [barcodeValue, items]);

  /* ---------------- ADD TO CART ---------------- */
// const addToCart = product => {
//   const price =
//     customerType === "retail" ? product.retail : product.wholesale;

//   const sgstPercent = Number(product.tax_one || 0);
//   const cgstPercent = Number(product.tax_two || 0);

//   setCart(prev => {
//     const found = prev.find(p => p.id === product.id);

//     if (found) {
//       const newQty = found.qty + 1;
//       const subTotal = newQty * price;

//       const sgst = (subTotal * sgstPercent) / 100;
//       const cgst = (subTotal * cgstPercent) / 100;

//       return prev.map(p =>
//         p.id === product.id
//           ? {
//               ...p,
//               qty: newQty,
//               price,
//               subTotal,
//               sgst,
//               cgst,
//               total: subTotal + sgst + cgst
//             }
//           : p
//       );
//     }

//     const subTotal = price;
//     const sgst = (subTotal * sgstPercent) / 100;
//     const cgst = (subTotal * cgstPercent) / 100;

//     return [
//       ...prev,
//       {
//         ...product,
//         qty: 1,
//         price,
//         subTotal,
//         sgst,
//         cgst,
//         total: subTotal + sgst + cgst
//       }
//     ];
//   });
// };
const addToCart = (product) => {
  //  BLOCK IF OUT OF STOCK
  if (product.stock <= 0) {
    alert(`${product.name} is out of stock`);
    return;
  }

  const existingItem = cart.find(p => p.id === product.id);

  if (existingItem && existingItem.qty >= product.stock) {
    alert(`Only ${product.stock} units available for ${product.name}`);
    return;
  }

  const price =
    customerType === "retail" ? product.retail : product.wholesale;

  const sgstPercent = Number(product.tax_one || 0);
  const cgstPercent = Number(product.tax_two || 0);

  const totalTaxPercent = sgstPercent + cgstPercent;

  setCart(prev => {
    const found = prev.find(p => p.id === product.id);


    if (found) {
      const newQty = found.qty + 1;
      // const subTotal = newQty * price;
      const lineTotal = newQty * price;
      const subTotal = lineTotal / (1 + totalTaxPercent / 100);

      const sgst = (subTotal * sgstPercent) / 100;
      const cgst = (subTotal * cgstPercent) / 100;

      return prev.map(p =>
        p.id === product.id
          ? {
              ...p,
              qty: newQty,
              price,
              subTotal,
              sgst,
              cgst,
              // total: subTotal + sgst + cgst
              total: subTotal
            }
          : p
      );
    }

    // const subTotal = price;
    // const subTotal = price / (1 + totalTaxPercent / 100);
    const subTotal = parseFloat((price / (1 + totalTaxPercent / 100)).toFixed(2));
    const sgst = (subTotal * sgstPercent) / 100;
    const cgst = (subTotal * cgstPercent) / 100;

    return [
      ...prev,
      {
        ...product,
        qty: 1,
        price,
        subTotal,
        sgst,
        cgst,
        // total: subTotal + sgst + cgst
        total: subTotal
      }
    ];
  });
  setTimeout(() => inputSearchRef.current?.focus(), 0);
};
  /* ---------------- REMOVE ITEM ---------------- */
  const removeItem = id => {
    setCart(prev => prev.filter(p => p.id !== id));
    setTimeout(() => inputSearchRef.current?.focus(), 0);
  };

  /* ---------------- TOTALS ---------------- */
  // const total = cart.reduce((s, i) => s + i.total, 0);
// const subTotal = cart.reduce((s, i) => s + (i.subTotal || 0), 0);

// const sgstTotal = cart.reduce(
//   (s, i) => s + (i.qty * (i.tax_one || 0)),
//   0
// );

// const cgstTotal = cart.reduce(
//   (s, i) => s + (i.qty * (i.tax_two || 0)),
//   0
// );

// const totalTax = sgstTotal + cgstTotal;
// const total = subTotal + totalTax;
const subTotal = cart.reduce((s, i) => s + (i.subTotal || 0), 0);

// const sgstTotal = cart.reduce((s, i) => s + (i.sgst || 0), 0);
// const cgstTotal = cart.reduce((s, i) => s + (i.cgst || 0), 0);
const sgstTotal = Number(
  cart.reduce((s, i) => s + (i.sgst || 0), 0).toFixed(2)
);

const cgstTotal = Number(
  cart.reduce((s, i) => s + (i.cgst || 0), 0).toFixed(2)
);

const totalTax = sgstTotal + cgstTotal;
// const total = parseFloat((subTotal + totalTax).toFixed(2));
const total = subTotal + totalTax;

const roundedTotal = Math.round(total); 
const roundOff = Math.round((roundedTotal - total) * 100) / 100;

  const change =
    cashPaid >= roundedTotal ? (cashPaid - roundedTotal).toFixed(2) : "0.00";



  /* ---------------- ACTIONS ---------------- */
  const handleCancel = () => {
    setSearchValue("");
    setBarcodeValue("");
    setCart([]);
    setCashPaid(0);
    setTimeout(() => inputSearchRef.current?.focus(), 0);
  };

  const handleNewSale = () => {
    setCart([]);
    setCashPaid(0);
    setIsModalOpen(false);
  };
  const resetSale = () => {
  setCart([]);
  setCashPaid(0);
  setSearchValue("");
  setBarcodeValue("");
  setSelectedCustomer(null);
  setCustomerSearch("");
  setPaymentType("cash");
  setCustomerType("retail");

  // refocus barcode scanner
  setTimeout(() => {
    inputSearchRef.current?.focus();
    fetchItems();
  }, 0);
};
 const handleSubmit = async () => {
  if (isSubmitting) return;
  if (cart.length === 0) {
    alert("Add at least one product");
    return;
  }

  // const cash = parseFloat(cashPaid) || 0;
  // if (paymentType === "cash" && cash < total) {
  //   alert(`Cash received (₹${cash.toFixed(2)}) is less than total (₹${total.toFixed(2)}). Please enter the correct amount.`);
  //   return;
  // }

  const cash = parseFloat(cashPaid) || 0;

  // BLOCK PRINT IF CASH NOT ENTERED
  if (paymentType === "cash" && cash <= 0) {
    alert("Please enter cash amount");
    return;
  }

  if (paymentType === "cash" && cash < roundedTotal) {
    alert(
      `Cash received (₹${cash.toFixed(2)}) is less than total (₹${roundedTotal.toFixed(
        2
      )}).`
    );
    return;
  }

  setIsSubmitting(true);

 const payload = {
  sub_total: Number(subTotal.toFixed(2)),
  total_amount: Number(roundedTotal.toFixed(2)),
  payment_type: paymentType,
  tax_type:taxType,
  customer_id: selectedCustomer?.id || null,
  customer_type: customerType,
  cash_received: paymentType === "cash" ? cash : 0,
  change_amount: paymentType === "cash" ? (cash - roundedTotal) : 0,
  roundoff: Number(roundOff.toFixed(2)),
  tax: Number(totalTax.toFixed(2)),
  sgst: Number(sgstTotal.toFixed(2)),
  cgst: Number(cgstTotal.toFixed(2)),
  igst:Number(totalTax.toFixed(2)),

  items: cart.map(item => ({
    item_id: item.id,
    item_name: item.name,
    barcode: item.barcode,
    quantity: String(item.qty),
    price: item.price,
    sub_total: Number(item.subTotal.toFixed(2)),
    sgst: taxType === "intra" ? Number(item.sgst.toFixed(2)) : 0,
    cgst: taxType === "intra" ?  Number(item.cgst.toFixed(2)) : 0,
    total: Number(item.total.toFixed(2)),
    tax: taxType === "inter"
      ? Number(totalTax.toFixed(2))  
       : Number(item.sgst.toFixed(2)) + Number(item.cgst.toFixed(2)),
  }))
};

  console.log("Payload to submit:", payload);

  try {
    const res = await fetch(`${configData.APP_URL}salesapi/sales-items`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    });

    const data = await res.json();

    if (data.success) {
      alert("Order saved successfully");
      const currentInvoiceNumber = data.invoice_number;
      //  handlePrint();
      // resetSale();
      setIsModalOpen(true);
      setShowPrintPopup(true);
      setInvoiceNumberForPrint(currentInvoiceNumber);
      await fetchInvoiceNumber();
    } else {
      console.log("Backend error response:", data);
      alert("Failed to save order due to: " + (data.error || "Unknown Error"));
      return;
    }
  } catch (err) {
    console.error(err);
    alert("Error submitting order");
  } finally {
    setIsSubmitting(false);
  }
};

const now = new Date();

// const quotationDate = now.toLocaleDateString();
// const quotationDate = now.toLocaleDateString("en-GB");
// const quotationTime = now.toLocaleTimeString();
  const quotationDate = now.toLocaleDateString('en-GB', {
      day: '2-digit',                
      month: '2-digit',              
      year: 'numeric'
  });

  const quotationTime = now.toLocaleTimeString('en-GB');


  const companydetails = async () => {
    try {
      const res = await fetch(API_BASE + "salesapi/showcom");
      const data = await res.json();
  
      if (data.company) {
        setCompanyDetail(data.company);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
      companydetails();
  }, []);

  if (!companyDetail) return;

  function capitalizeWords(str) {
    return str
      .split(" ")
      .map(word => (word.toLowerCase() === "and" ? "and" : word.charAt(0).toUpperCase() + word.slice(1)))
      .join(" ");
  }

  // Usage
  const totalInWords = toWords(Math.floor(roundedTotal)); // integer part
  const decimalPart = Math.round((roundedTotal - Math.floor(roundedTotal)) * 100);

  let totalInWordsWithDecimals = decimalPart
    ? `${totalInWords} rupees and ${toWords(decimalPart)} paise`
    : `${totalInWords} rupees`;

  totalInWordsWithDecimals = capitalizeWords(totalInWordsWithDecimals);


  // Group items by tax rate
  const groupedTaxes = cart.reduce((acc, item) => {

    const taxOneRate = Number(item.tax_one || 0);
    const taxTwoRate = Number(item.tax_two || 0);
    const igstRate = Number(item.tax_one || 0) + Number(item.tax_two || 0);
    const taxable = Number(item.subTotal || 0);

    const key = taxType === "inter"
    ? `${igstRate}`   //  group by combined rate
    : `${taxOneRate}_${taxTwoRate}`;

    if (!acc[key]) {
      acc[key] = {
        taxableValue: 0,
        taxOneRate: taxOneRate,
        taxTwoRate: taxTwoRate,
        igstRate: igstRate,
        taxOneAmount: 0,
        taxTwoAmount: 0,
        interTaxAmount:0,
      };
    }

    acc[key].taxableValue += taxable;
    acc[key].taxOneAmount += Number(item.sgst || 0);
    acc[key].taxTwoAmount += Number(item.cgst || 0);
    acc[key].interTaxAmount += Number(item.sgst || 0) + Number(item.cgst || 0);

    return acc;

  }, {});

  // Convert grouped object to array for mapping
  // const taxRows = Object.values(groupedTaxes);
  const taxRows = Object.values(groupedTaxes)
    .sort((a, b) => (a.taxOneRate + a.taxTwoRate) - (b.taxOneRate + b.taxTwoRate));

  taxRows.forEach(row => {
    row.taxableValue = Number(row.taxableValue.toFixed(2));
    row.taxOneAmount = Number(row.taxOneAmount.toFixed(2));
    row.taxTwoAmount = Number(row.taxTwoAmount.toFixed(2));
    row.interTaxAmount = Number(row.interTaxAmount.toFixed(2));
  });

  // Calculate totals
  const totalTaxable = taxRows.reduce((sum, row) => sum + row.taxableValue, 0);
  const totalCGST = taxRows.reduce((sum, row) => sum + Number(row.taxTwoAmount || 0), 0);
  const totalSGST = taxRows.reduce((sum, row) => sum + Number(row.taxOneAmount || 0), 0);
  const totalIGST = taxRows.reduce((sum, row) => sum + Number(row.interTaxAmount || 0), 0);
  const totalTaxAmount = taxType === "inter"
  ? totalIGST
  : totalCGST + totalSGST;


  const taxInWords = toWords(Math.floor(totalTaxAmount)); 
  const decimalTaxPart = Math.round((totalTaxAmount - Math.floor(totalTaxAmount)) * 100);

  let taxInWordsWithDecimals = decimalTaxPart
      ? `INR ${taxInWords} and ${toWords(decimalTaxPart)} paise`
      : `INR ${taxInWords}`;

  taxInWordsWithDecimals = capitalizeWords(taxInWordsWithDecimals);
const { FIRST: MAX_ROWS_FIRST, LAST: MAX_ROWS_LAST } = getRowConfig(printType || "invoice-a4");

const paginateItems = (items) => {
        const pages = [];
        let remaining = [...items];

        while (remaining.length > 0) {
            if (remaining.length > MAX_ROWS_FIRST) {
            pages.push(remaining.slice(0, MAX_ROWS_FIRST));
            remaining = remaining.slice(MAX_ROWS_FIRST);
            } else {
            if (remaining.length <= MAX_ROWS_LAST) {
                pages.push(remaining);
            } else {
                // Distribute so last page is small (2–3 items)
                const lastPageCount = Math.min(3, remaining.length);
                const secondLastCount = remaining.length - lastPageCount;

                pages.push(remaining.slice(0, secondLastCount)); // e.g. 5
                pages.push(remaining.slice(secondLastCount));    // e.g. 2–3
            }
            break;
            }
        }

        return pages;
    };

      const pages = paginateItems(cart);
      let runningIndex = 0;



  return (
    <div className="sales-by-display-main-container">
      <Helmet>
        <title>Sales By Display</title>
      </Helmet>

      <div className="pos-body sales-by-display-container">
        {/* LEFT PANEL */}
        <div className="pos-left">
         <div className="pos-flex pos-top-fields">

  <div className="pos-field">
    <label>Customer Type</label>
    <select
      value={customerType}
      onChange={(e) => setCustomerType(e.target.value)}
    >
      <option value="retail">Retail</option>
      <option value="wholesale">Wholesale</option>
    </select>
  </div>

  <div className="pos-field pos-field-wide">
    <label>Customer</label>
    <Autocomplete
      className="customer-search"
      options={customerOptions}
      value={selectedCustomer}
      getOptionLabel={(option) => option.name}
      filterOptions={(x) => x}
      onChange={(e, value) => setSelectedCustomer(value)}
      inputValue={customerSearch}
      onInputChange={(e, value) => setCustomerSearch(value)}
      renderOption={(props, option) => (
        <li {...props} style={{ display: "flex", flexDirection: "column", padding: "6px 10px" }}>
          <span style={{ fontWeight: 500, fontSize: "14px", color: "#333" }}>
            {option.name}
          </span>
          <span style={{ fontSize: "12px", color: "#666", marginTop: "2px" }}>
            {option.phone_number && <span>Ph: {option.phone_number} </span>}
            {(option.phone_number && option.gst_number) && <> | </>}
            {option.gst_number && <span>GST: {option.gst_number}</span>}
          </span>
        </li>
      )}
      renderInput={(params) => (
        <TextField {...params} size="small" placeholder="Select customer" />
      )}
    />
  </div>

  <div className="pos-field pos-field-wide">
    <label>Product</label>
    <TextField
      value={searchValue}
      onChange={(e) => setSearchValue(e.target.value)}
      placeholder="Search product"
      size="small"
      fullWidth
    />
  </div>

  <div className="pos-field">
    <label>Scan here</label>
    <input
      ref={inputSearchRef}
      className="barcode-input"
      value={barcodeValue}
      onChange={(e) => setBarcodeValue(e.target.value)}
      placeholder="Scan barcode"
      onKeyDown={handleKeyDown}
      autoComplete="off"
    />
  </div>
   <div className="pos-field">
    <label>Tax Type</label>
    <select
      value={taxType}
      onChange={(e) => setTaxType(e.target.value)}
    >
      <option value="intra">SGST + CGST</option>
      <option value="inter">IGST</option>
    </select>
  </div>

</div>
       <div className="product-grid">
          {loading && <p>Loading products...</p>}
          {error && <p style={{color:"red"}}>{error}</p>}

       {!loading && currentItems.map(item => (
         <div
  key={item.id}
  className={`product-card ${item.stock <= 0 ? "out-of-stock" : ""}`}
  // onClick={() => item.stock > 0 && addToCart(item)}
  onClick={() => {
  if (item.stock > 0) {
    addToCart(item);
    setTimeout(() => inputSearchRef.current?.focus(), 0);
  }
}}
>
  <img
    src={item.image}
    alt={item.name}
    className="product-image"
    onError={(e) => {
      e.target.src = "/images/img_unavailable.png";
    }}
  />

  {item.stock <= 0 && (
    <>
    <div className="out-badge">UNAVAILABLE</div>
       {/* <span style={{ marginLeft: 10, fontSize: '0.8rem', background: '#ff9800', color: '#fff', padding: '2px 6px', borderRadius: '4px' }}>
                    Restock
                  </span> */}
                  </>
  )}

  <h4>{item.name}</h4>
  <small>{item.barcode}</small>

  <div className="product-footer">
    <span>Stock: {item.stock}</span>
    <span>
      ₹{customerType === "retail"
        ? item.retail.toFixed(2)
        : item.wholesale.toFixed(2)}
    </span>
  </div>
</div>
        ))}
        </div>
        <Pagination
          currentPage={currentPage}
          totalItems={filteredItems.length} 
          itemsPerPage={itemsPerPage}
          onPageChange={handlePageChange}
        />
        </div>

        {/* RIGHT PANEL */}
        <div className="pos-right">
            <div className="pos-right-heading">
                <div>
                    <FontAwesomeIcon className="pos-right-heading-icon" icon={faShoppingBasket} /><h3>Current Order</h3>
                </div>
                <span onClick={handleCancel} style={{color: "red", lineHeight: "3.6", marginRight:"5px"}}>CLEAR</span>
            </div>

          {cart.length === 0 ? (
            <p className="empty-cart">Start scanning...</p>
          ) : (
            cart.map(item => (
              <div className="order-item" key={item.id}>
                <div>
                  {item.name} × {item.qty}
                </div>
                <div>
                <span>
                  ₹{Number(item.total).toFixed(2)}
                  </span>&nbsp;&nbsp;
                  <span style={{marginRight:"5px"}}>
                  <FontAwesomeIcon
                    icon={faTrash}
                    className="delete"
                    onClick={() => removeItem(item.id)}
                  />
                  </span>
                </div>
              </div>
            ))
          )}

          <div className="payment">
            {/* <h2>Total: ₹{total.toFixed(2)}</h2> */}
            <div className="payment-summary">
            <div><span>Sub Total</span>&nbsp;<span>₹{subTotal.toFixed(2)}</span></div>
            {taxType === "intra" ? (<>
            <div><span>SGST</span>&nbsp;<span>₹{sgstTotal.toFixed(2)}</span></div>
            <div><span>CGST</span>&nbsp;<span>₹{cgstTotal.toFixed(2)}</span></div>
            </>
              ) : (
                <div><span>IGST</span>&nbsp;<span>₹{totalTax.toFixed(2)}</span></div>)}
            <div><span>Round Off</span>&nbsp;<span>{roundOff.toFixed(2)}</span></div>
            <h2>Total: ₹{roundedTotal.toFixed(2)}</h2>
          </div>

            <input
              type="number"
              className="cash-input no-scroll"
              value={cashPaid}
              onChange={e => setCashPaid(Number(e.target.value) || 0)}
              placeholder="Cash given"
              onWheel={(e) => {
                e.preventDefault();
                e.currentTarget.blur(); 
              }}
            />

            <div className="quick-cash">
              <button onClick={() => setCashPaid(5)}>₹5</button>
              <button onClick={() => setCashPaid(10)}>₹10</button>
              <button onClick={() => setCashPaid(20)}>₹20</button>
              <button onClick={() => setCashPaid(50)}>₹50</button>
            </div>

            <h4>Change: ₹{change}</h4>

            <div className="actions">
              <button className="cancel" 
              style={{cursor:"pointer"}}
              onClick={handleCancel}>
                Cancel
              </button>
              <button
                className="save save-print"
                disabled={isSubmitting}
                style={{ cursor: "pointer", backgroundColor: "#16a34a" }}
                // onClick={() => {
                //   canSaveOrPrint();
                //   onPrintClick();
                //   handleSubmit();
                // }}
                 onClick={handleSubmit}
              >
                <FontAwesomeIcon icon={faPrint} />  Save & Print
              </button>
            </div>
          </div>
        </div>
      </div>

      
  {/* {isModalOpen && (
  <div className="modal-overlay">
    <div className="modal-box">
      <div className="success-icon">✓</div>

      <h2>Payment Successful!</h2>

      <div className="summary">
        <div>
          <span>Total:</span>
          <span>₹{total.toFixed(2)}</span>
        </div>
        <div>
          <span>Paid:</span>
          <span>₹{cashPaid.toFixed(2)}</span>
        </div>
        <div className="change">
          <span>CHANGE</span>
          <span>₹{change}</span>
        </div>
      </div>

      <div className="modal-actions">
        <button className="dark" onClick={handlePrint}>
          Print Receipt
        </button>
        <button className="primary" onClick={handleNewSale}>
          New Sale
        </button>
      </div>
    </div>
  </div>
)} */}
    {showPrintPopup && (
      <div className="modal-overlay">
        <div className="modal-content">
          <h3 style={{margin: "2px 0px", textAlign: "center"}}>Select Print Size</h3>

          <button onClick={() => onPrintClick("receipt-58mm")}>
            Print 2"
          </button>

          {/* <button onClick={() => onPrintClick("receipt-152mm")}>
            Print 6"
          </button> */}

          <button onClick={() => onPrintClick("invoice-a4")}>
            Print A4
          </button>
          <button onClick={() => onPrintClick("invoice-a4")}>
            Print A5
          </button>

          <button onClick={() => {setShowPrintPopup(false); resetSale();}}>
            Cancel
          </button>
        </div>
      </div>
    )}

    <div ref={contentRef} className={`printContent ${printType}`}>
                <>
                    <div className="receipt receipt-58mm">
                        <h2 className="center bold" style={{marginBottom: "0"}}>{companyDetail.company_name}</h2>
                        <div className="center small">
                            <span>{companyDetail.company_address}</span><br />
                            <span>GST No.: {companyDetail.gst_number}</span><br />
                            <span>Contact: {companyDetail.phone}</span>
                        </div>
                        <div className="dash-line"></div>    
                        <h2 className="center bold">Tax Invoice</h2>

                        <div className="center small">
                            <span>
                                Invoice #: {invoiceNumberForPrint}
                            </span>
                            <br />
                            Payment: {paymentType === "cash" ? "Cash" : "Credit"}
                            <br />
                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                <span>{quotationDate}</span>
                                <span>{quotationTime}</span>
                            </div>
                        </div>

                        <div className="dash-line"></div>

                        <div className="items-header">
                            <span>Qty</span>
                            <span>Item</span>
                            <span className="right">Price</span>
                        </div>

                        <div className="dash-line"></div>

                        {cart.map(line => (
                          <div key={line.id} className="item-row">
                            <span style={{textAlign: "center", width: "21px"}}>{line.qty}</span>
                            <span className="item-name">{line.name}</span>
                            <span className="right">₹{line.total.toFixed(2)}</span>
                          </div>
                        ))}

                        <div className="dash-line"></div>
                        <div className="row">
                            <span>SUBTOTAL:</span>
                            <span>₹{subTotal.toFixed(2)}</span>
                        </div>
                         {taxType === "intra" ? (<>
                        <div className="row">
                            <span>SGST:</span>
                            <span>₹{totalSGST.toFixed(2)}</span>
                        </div>
                        <div className="row">
                            <span>CGST:</span>
                            <span>₹{totalCGST.toFixed(2)}</span>
                        </div> 
                        </>
                         ) : (
                          <div className="row">
                            <span>IGST:</span>
                            <span>₹{totalIGST.toFixed(2)}</span>
                        </div> )}
                        <div className="row">
                            <span><i>roundoff:</i></span>
                            <span>{roundOff.toFixed(2)}</span>
                        </div> 

                        <div className="dash-line"></div>
                        <div className="row total bold">
                            <span>TOTAL:</span>
                            <span>₹{roundedTotal.toFixed(2)}</span>
                        </div>
                        <div className="dash-line"></div>
                        <div className="dash-line"></div>

                        {paymentType === "cash" && parseFloat(cashPaid) >= roundedTotal && (
                          <>
                            <div className="row">
                              <span>CASH:</span>
                              <span>₹{parseFloat(cashPaid).toFixed(2)}</span>
                            </div>
                            <div className="row">
                              <span>CHANGE:</span>
                              <span>₹{(parseFloat(cashPaid) - roundedTotal).toFixed(2)}</span>
                            </div>
                          </>
                        )}

                        <div className="center thanks">*** THANK YOU ***</div>

                    </div>


            {/* 152mm receipt & A4 invoice */}
            {pages.map((pageItems, pageIndex) => {
             const isLastPage = pageIndex === pages.length - 1;

            const maxRows = isLastPage ? MAX_ROWS_LAST : MAX_ROWS_FIRST;
            const emptyRows = Math.max(0, maxRows - pageItems.length);
            const startIndex = runningIndex;
            runningIndex += pageItems.length;
            return (
            <div key={pageIndex} className="invoice-a4">
                <div style={{ fontSize: "14px", padding: "10px", textAlign: "center" }}>Tax Invoice</div>
                <table className="invoice-table">

                    <thead>
                    {/* Company Section */}
                    <tr>
                        <td style={{ width: "60%", verticalAlign: "top" }}>
                            <table className="no-border-top no-border-left no-border-bottom" style={{ width: "100%" }}>
                                <thead>
                                    <tr>
                                        <td style={{fontWeight: "700"}}>{companyDetail.company_name}</td>
                                    </tr>
                                    <tr>
                                        <td>{companyDetail.company_address}</td>
                                    </tr>
                                    <tr>
                                        <td>GSTIN: {companyDetail.gst_number}</td>
                                    </tr>
                                    <tr>
                                        <td>Contact: {companyDetail.phone}</td>
                                    </tr>
                                    {/* <tr>
                                        <td>PAN No.:</td>
                                    </tr> */}
                                </thead>
                            </table>
                        </td>

                        <td style={{ width: "40%" }}>
                            <table className="no-border-top no-border-left no-border-right no-border-bottom" style={{ width: "100%" }}>
                                <thead>
                                    <tr>
                                        <td>Date: {quotationDate}</td>
                                    </tr>
                                    <tr>
                                        <td>Invoice #: {invoiceNumberForPrint}</td>
                                    </tr>
                                    {/* <tr>
                                        <td>PAN No:</td>
                                    </tr> */}
                                    <tr>
                                        <td>Payment Mode: {paymentType === "cash" ? "Cash" : "Credit"}</td>
                                    </tr>
                                      <tr>
                                        <td>&nbsp;</td>
                                    </tr>
                                </thead>
                            </table>
                        </td>
                    </tr>

                    {/* Billing Section */}

                    <tr>
                        <td colSpan={2}>
                            <table className="no-border-bottom no-border-left no-border-right" style={{ width: "100%" }}>
                              {selectedCustomer && <>
                                  <thead>
                                    <tr><td>Billing To</td></tr>
                                      <tr>
                                        <td>
                                          <span style={{fontWeight: "700"}}>{selectedCustomer.name && <>{selectedCustomer.name}</>}</span>
                                     
                                          <span>{selectedCustomer.address && <>{selectedCustomer.address}</>}</span>&nbsp;
                                     
                                          <span>{selectedCustomer.gst_number && <>| GSTIN: {selectedCustomer.gst_number}</>}</span>&nbsp;
                                     
                                          <span>{selectedCustomer.phone_number && <>| Contact: {selectedCustomer.phone_number}</>}</span>&nbsp;
                                     
                                          <span>{selectedCustomer.email && <>| Email ID: {selectedCustomer.email}</>}</span>
                                          </td>
                                      </tr>
                                </thead>
                              </>}
                            </table>
                        </td>
                        {/* <td style={{ width: "40%" }}></td> */}
                    </tr>

                    {/* Items Table */}
                    <tr>
                        <td colSpan="2">

                        <table className="no-border-left no-border-right invoice-main-table invoice-main-table-sales no-border-bottom-th" style={{ width: "100%", padding: "0px" }}>
                              <colgroup>
                                            <col style={{width: "5%"}} />
                                            <col style={{width: "33%"}} />
                                            <col style={{width: "13%"}} />
                                            <col style={{width: "10%"}} />
                                            <col style={{width: "7%"}} />
                                            <col style={{width: "15%"}} />
                                            <col style={{width: "17%"}} />
                            </colgroup>
                            <thead>
                                <tr>
                                    <th style={{fontSize: "12px"}}>Sl No.</th>
                                    <th>Description of Goods</th>
                                    <th>HSN/SAC</th>
                                    <th>Qty</th>
                                    <th>per</th>
                                    <th>Rate</th>
                                    {/* <th>Disc. %</th> */}
                                    <th>Amount</th>
                                </tr>
                            </thead>
                            </table>
                                    </td>
                                </tr>
                                    </thead>
                                    
                            <tr>
                                <td colSpan="2">
                                <table className="no-border-left no-border-right no-border-top no-border-bottom invoice-main-table invoice-main-table-sales" style={{ width: "100%", padding: "0px" }}>
                                    <colgroup>
                                            <col style={{width: "5%"}} />
                                            <col style={{width: "33%"}} />
                                            <col style={{width: "13%"}} />
                                            <col style={{width: "10%"}} />
                                            <col style={{width: "7%"}} />
                                            <col style={{width: "15%"}} />
                                            <col style={{width: "17%"}} />
                                    </colgroup>
                            <tbody>

                                {pageItems.map((line,idx) => (
                                    <tr key={line.id}>
                                   <td>{startIndex + idx + 1}</td>
                                    <td style={{fontWeight: "700", textAlign: "left"}}>{line.name}</td>
                                    <td>{line.hsn_code && <>{line.hsn_code}</>}</td>
                                    <td>{line.qty}</td>
                                    <td>{line.unit && <>{line.unit}</>}</td>
                                    {/* <td>₹{Number(line.total || 0).toFixed(2)}</td> */}
                                    <td>₹{line.qty ? (line.total / line.qty).toFixed(2) : "0.00"}</td>
                                    <td>
                                      ₹{Number(line.total || 0).toFixed(2)}
                                      {/* ₹{(line.qty * Number(line.total || 0)).toFixed(2)} */}
                                    </td>
                                    </tr>
                                ))}
                                 {Array.from({ length: emptyRows }).map((_, i) => (
                                  <tr key={`empty-${i}`}>
                                    <td>&nbsp;</td>
                                    <td></td><td></td><td></td>
                                    <td></td><td></td><td></td>
                                  </tr>
                                ))}
                                 </tbody>
                                    
                                </table>
                                
                                </td>
                            </tr>
                                {/* <tr></tr> */}
                              {isLastPage && (
                                <tfoot>
                              <tr><td colSpan={2}>
                              <table className="invoice-main-table invoice-main-table-sales no-border-left no-border-right no-border-top" style={{width:'100%'}}>
                                  <colgroup>
                                            <col style={{width: "5%"}} />
                                            <col style={{width: "33%"}} />
                                            <col style={{width: "13%"}} />
                                            <col style={{width: "10%"}} />
                                            <col style={{width: "7%"}} />
                                            <col style={{width: "15%"}} />
                                            <col style={{width: "17%"}} />
                                  </colgroup>
                                   {taxType === "intra" ? (
                                <>   
                                <tr>
                                    <td></td>
                                    <td style={{fontWeight: "700", textAlign: "right"}}>SGST</td>
                                    <td></td><td></td><td></td><td></td>
                                    <td>₹{totalSGST.toFixed(2)}</td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td style={{fontWeight: "700", textAlign: "right"}}>CGST</td>
                                    <td></td><td></td><td></td><td></td>
                                    <td>₹{totalCGST.toFixed(2)}</td>
                                </tr>
                                </>
                                ) : (
                                   <tr>
                                    <td></td>
                                    <td style={{fontWeight: "700", textAlign: "right"}}>IGST</td>
                                    <td></td><td></td><td></td><td></td>
                                    <td>₹{totalIGST.toFixed(2)}</td>
                                </tr>)}
                                <tr>
                                    <td></td>
                                    <td style={{fontWeight: "700", textAlign: "right"}}><i>Roundoff</i></td>
                                    <td></td><td></td><td></td><td></td>
                                    <td>{roundOff.toFixed(2)}</td>
                                </tr>
                                <tr style={{ fontWeight: "bold", borderTop: "1px solid #111" }}>
                                    <td></td>
                                    <td>Total</td>
                                    <td></td><td></td><td></td><td></td>
                                    <td>₹{roundedTotal.toFixed(2)}</td>
                                </tr>

                             </table>
                            </td></tr>

                    <tr>
                        <td colSpan={2} style={{padding: "3px"}}>
                        <div>Amount Chargeable (in words)</div>
                        <div style={{fontWeight: "700"}}>{totalInWordsWithDecimals} only</div>
                        </td>
                    </tr>

                            <>     
                            <tr>
                                <td colSpan="2">
                                    <table className="invoice-tax-table no-border-right no-border-left" style={{ width: "100%", borderCollapse: "collapse" }}>
                                        <thead>
                                            {taxType === "intra" ? (
                                              <>
                                            <tr>
                                                <th rowSpan={2}>Taxable<br />Value</th>
                                                <th colSpan={2}>CGST</th>
                                                <th colSpan={2}>SGST/UTGST</th>
                                                <th rowSpan={2}>Total<br />Tax Amount</th>
                                            </tr>
                                            <tr>
                                                <th>Rate</th>
                                                <th>Amount</th>
                                                <th>Rate</th>
                                                <th>Amount</th>
                                            </tr>
                                             </>
                                            ) : (
                                                <>
                                                <tr>
                                                <th rowSpan={2}>Taxable<br />Value</th>
                                                <th colSpan={2}>IGST</th>
                                                <th rowSpan={2}>Total<br />Tax Amount</th>
                                            </tr>
                                            <tr>
                                                <th>Rate</th>
                                                <th>Amount</th>
                                            </tr>
                                            </>)}
                                        </thead>
                                        <tbody>
                                            {taxRows.map((row, idx) => (
                                              taxType === "intra" ? (
                                                <tr key={idx}>
                                                    <td style={{textAlign: "right" }}>
                                                    ₹{row.taxableValue.toFixed(2)}
                                                    </td>
                                                    <td style={{textAlign: "center" }}>
                                                    {row.taxTwoRate}%
                                                    </td>
                                                    <td style={{textAlign: "right" }}>
                                                    ₹{row.taxTwoAmount.toFixed(2)}
                                                    </td>
                                                    <td style={{textAlign: "center" }}>
                                                    {row.taxOneRate}%
                                                    </td>
                                                    <td style={{textAlign: "right" }}>
                                                    ₹{row.taxOneAmount.toFixed(2)}
                                                    </td>
                                                    <td style={{textAlign: "right" }}>
                                                    ₹{(row.taxOneAmount + row.taxTwoAmount).toFixed(2)}
                                                    </td>
                                                </tr>
                                                ) : (
                                                    <tr key={idx}>
                                                    <td style={{textAlign: "right" }}>
                                                    ₹{row.taxableValue.toFixed(2)}
                                                    </td>
                                                     <td style={{ textAlign: "center" }}>
                                                    {row.igstRate}%
                                                  </td>
                                                  <td style={{ textAlign: "right" }}>
                                                    ₹{row.interTaxAmount.toFixed(2)}
                                                  </td>
                                                    <td style={{textAlign: "right" }}>
                                                    ₹{(row.taxOneAmount + row.taxTwoAmount).toFixed(2)}
                                                    </td>
                                                </tr>)
                                            ))}

                                            {/* Total row */}
                                            <tr style={{ fontWeight: "bold" }}>
                                                <td style={{textAlign: "right" }}>
                                                    Total: ₹{totalTaxable.toFixed(2)}
                                                </td>
                                                 {taxType === "intra" ? (<>
                                                <td></td>
                                                <td style={{textAlign: "right" }}>
                                                    ₹{totalCGST.toFixed(2)}
                                                </td>
                                                <td></td>
                                                <td style={{textAlign: "right" }}>
                                                    ₹{totalSGST.toFixed(2)}
                                                </td></>) : (<> 
                                                <td></td>
                                                <td style={{textAlign: "right" }}>
                                                    ₹{totalIGST.toFixed(2)}
                                                </td>
                                                </>)}
                                                <td style={{textAlign: "right" }}>
                                                    ₹{totalTaxAmount.toFixed(2)}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>

                            <tr>
                                <td colSpan={2} style={{height: "50px", padding: "3px"}}>
                                    <div>Tax Amount (in words)</div>
                                    <div style={{fontWeight: "700"}}>{taxInWordsWithDecimals} only</div>
                                </td>
                            </tr>
                        </>  

                    <tr>
                        <td colSpan={2}>
                            <table style={{ width: "100%", tableLayout: "fixed" }} className="no-border-left no-border-right">
                                <colgroup>
                                    <col style={{ width: "50%" }} />
                                    <col style={{ width: "50%" }} />
                                </colgroup>

                                <tbody>
                                    <tr>
                                    <td style={{padding: "3px 10px 3px 3px"}}>
                                        <span style={{fontSize: "13px", textDecoration: "underline"}}>Declaration</span><br />
                                        <span>We declare that this invoice shows the actual price of the goods described and that all particulars are true and correct.</span>
                                    </td>
                                    {companyDetail.account_number && 
                                    <td>
                                        <div>Company's Bank Details</div>
                                        <div>Bank Name: {companyDetail.bank_name && <span style={{fontWeight: "700"}}>{companyDetail.bank_name}</span>}</div>
                                        <div>A/c No.: {companyDetail.account_number && <span style={{fontWeight: "700"}}>{companyDetail.account_number}</span>}</div>
                                        <div>Branch & IFS Code: <span style={{fontWeight: "700"}}>{companyDetail.bank_branch && <span>{companyDetail.bank_branch}</span>}
                                        {companyDetail.ifs_code && <span> & {companyDetail.ifs_code}</span>}</span></div>
                                    </td>}
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>

                    {/* Footer */}
                    <tr>
                        <td colSpan={2}>
                            <table style={{ width: "100%", tableLayout: "fixed" }} className="no-border">
                                <colgroup>
                                    <col style={{ width: "50%" }} />
                                    <col style={{ width: "50%" }} />
                                </colgroup>

                                <tbody>
                                    <tr>
                                    <td style={{ height: "70px" }}>
                                        Customer's Seal and Signature
                                    </td>

                                    <td style={{ textAlign: "right", height: "70px", borderLeft: "1px solid #111"}}>
                                        <div style={{display:"flex", flexDirection:"column", height:"100%"}}>
                                            <div style={{fontWeight: "700"}}>for {companyDetail.company_name}</div>
                                            <div style={{ marginTop: "auto" }}>Authorised Signatory</div>
                                        </div>
                                    </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>

                    </tfoot>)}

                </table>
            </div>)})}
        </>
    </div>


    </div>
  );
};

export default SalesByDisplay;